import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { useCopyFileUrl } from 'src/hooks/useCopyFileUrl';

type CopyFileLinkButtonProps = {
  fileUrl: string;
} & Pick<IconButtonProps, 'size' | 'sx' | 'color'>;

export default function CopyFileLinkButton({ fileUrl, size = 'small', sx, color }: CopyFileLinkButtonProps) {
  const { t } = useTranslation();
  const copyFileUrl = useCopyFileUrl();

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    void copyFileUrl(fileUrl);
  };

  return (
    <Tooltip title={t('system.fileManager.copyLink')}>
      <IconButton
        size={size}
        color={color}
        aria-label={t('system.fileManager.copyLink')}
        onClick={handleClick}
        sx={sx}
      >
        <ContentCopyIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
